<template>
  <div
    class="flex justify-start bg-body-primary border-t border-linear-g-primary p-4 fixed w-full -ml-4 bottom-0 lg:relative lg:p-0 lg:border-none lg:m-0 lg:mt-24"
  >
    <ButtonDefault
      id="back-button"
      label="Back"
      class="mr-auto font-semibold uppercase text-sm px-4 py-1.5 border border-solid border-button-guest-primary rounded font-button text-button-guest-primary"
      guest
      @click="onBack"
    />
    <ReservationCheckoutTimer v-if="reservation && display_timer" class="mr-auto" />
    <ButtonDefault
      id="next-button"
      class="px-4 uppercase border border-solid rounded font-semibold bg-button-guest-primary font-button text-button-label border-button-guest-primary disabled:bg-disabled disabled:cursor-not-allowed disabled:border-disabled disabled:text-white"
      :class="{ invisible: hideNextButton }"
      :label="nextButtonLabel"
      @click="handleClick"
      :disabled="isNextButtonDisabled && !shouldGoToSetTables"
      guest
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import ButtonDefault from '@/common/components/atoms/ButtonDefault.vue'
import ReservationCheckoutTimer from '@/modules/guestUi/components/molecules/ReservationCheckoutTimer.vue'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'click:next'): void
}>()

const props = withDefaults(
  defineProps<{
    nextButtonText?: string
    isNextButtonDisabled?: boolean
    hideNextButton?: boolean
  }>(),
  {
    nextButtonText: 'Next',
    isNextButtonDisabled: false,
    hideNextButton: false,
  },
)

const { reservation, is_timer_expired } = storeToRefs(useCheckoutStore())
const { display_timer } = storeToRefs(useSettingStore())

const route = useRoute()
const shouldGoToSetTables = computed<boolean>(() => {
  return route.name === 'payment' && is_timer_expired.value
})
const nextButtonLabel = computed<string>(() => {
  return shouldGoToSetTables.value ? 'Select Tables' : props.nextButtonText
})

const router = useRouter()
function handleClick() {
  if (shouldGoToSetTables.value) router.push({ name: 'setTable' })
  else emit('click:next')
}

function onBack() {
  history.go(-1)
}
</script>
